(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const variants = JSON.parse(section.querySelector('[data-product-json]').textContent);
      const select = section.querySelector('[data-variant-select]');
      const options = section.querySelector('.js-options');
      const button = section.querySelector('[data-add]');
      const main = section.querySelector('#ProductMainImage');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-compare]');
      const money = cents => new Intl.NumberFormat(section.dataset.locale, {style:'currency',currency:section.dataset.currency,currencyDisplay:'code'}).format(cents / 100);
      options.hidden = false;
      section.querySelector('.variant-fallback').hidden = true;
      function showImage(src, id) {
        if (!main || !src) return;
        main.removeAttribute('srcset'); main.src = src;
        section.querySelectorAll('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.imageId == id)));
      }
      section.querySelectorAll('[data-gallery-src]').forEach(b => b.addEventListener('click', () => showImage(b.dataset.gallerySrc,b.dataset.imageId)));
      options.addEventListener('change', () => {
        const selected = [...options.querySelectorAll('.option-group')].map(g => g.querySelector('input:checked')?.value);
        const variant = variants.find(v => v.options.every((o,i) => o === selected[i]));
        button.disabled = !variant?.available;
        select.disabled = !variant;
        section.querySelector('[data-product-payment]').hidden = !variant?.available;
        button.textContent = !variant ? button.dataset.unavailable : variant.available ? button.dataset.available : button.dataset.soldOut;
        section.querySelector('[data-product-status]').textContent = !variant ? button.dataset.unavailable : !variant.available ? button.dataset.soldOut : '';
        if (!variant) return;
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        price.textContent = money(variant.price);
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = compare.hidden ? '' : money(variant.compare_at_price);
        const u = new URL(location.href); u.searchParams.set('variant',variant.id); history.replaceState({},'',u);
        if (variant.featured_image) showImage(variant.featured_image.src,variant.featured_image.id);
      });

    });
  }
  document.addEventListener('keydown', e => { if(e.key === 'Escape') document.querySelectorAll('.site-header details[open]').forEach(d => {d.open=false;d.querySelector('summary')?.focus();}); });
  document.addEventListener('click', e => document.querySelectorAll('.site-header details[open]').forEach(d => {if(!d.contains(e.target))d.open=false;}));
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
})();
